/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddNoteAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContent from 'DesignSystem/Popover/PopoverContent/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2AddAppointmentNote from 'DesignSystem/Svgs/Tysiav2AddAppointmentNote/index'



/** @type {import('Simple/types.js').View} */
export default function AddNoteAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/AdditionalOptions/Content/AddNoteAction"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let appointmentOverlayNoteValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'note',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 width="100%"
 type="ghost"
 size="small"
 backgroundColor={dtColorsWhite}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2AddAppointmentNote
{...childProps}
  viewPath={`${viewPath}/Tysiav2AddAppointmentNote`}
 width={14}
 height={14}
 fill2={appointmentOverlayNoteValueData ? dtColorsNeutral900 : dtColorsNeutral400}
 data="appointment_overlay.note"
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContent
{...childProps}
  viewPath={`${viewPath}/PopoverContent`}
 width="auto"
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContent>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}